import {
  type DynamicClient,
  InvalidParamError,
  getActiveNetworkData,
} from '@dynamic-labs-sdk/client';
import type { ConfirmTransactionParams } from '@dynamic-labs-sdk/client/core';
import { assertDefined } from '@dynamic-labs-sdk/client/core';

import { createPublicClientFromNetworkData } from '../../viem/createPublicClientFromNetworkData';
import { isEvmWalletAccount } from '../isEvmWalletAccount';

/**
 * Waits for an EVM transaction to be confirmed on-chain.
 *
 * @param params.transactionHash - The transaction hash to wait for.
 * @param params.walletAccount - The EVM wallet account used to resolve the active network.
 * @param client - The Dynamic client instance.
 * @not-instrumented
 */
export const evmConfirmTransaction = async (
  { transactionHash, walletAccount }: ConfirmTransactionParams,
  client: DynamicClient
): Promise<void> => {
  if (!isEvmWalletAccount(walletAccount)) {
    throw new InvalidParamError('Wallet account is not an EVM wallet account');
  }

  const { networkData } = await getActiveNetworkData({ walletAccount }, client);

  assertDefined(
    networkData,
    `No network data found for wallet account ${walletAccount.address}`
  );

  const publicClient = createPublicClientFromNetworkData({ networkData });

  await publicClient.waitForTransactionReceipt({
    hash: transactionHash as `0x${string}`,
  });
};
